import Assignments from './Assignments'
import Administration from './Administration'
import Reports from './Reports'
import Review from './Interview'
import Users from './Users'
import Maps from './Maps'
import WebInterviewSetup from './WebInterviewSetup'
import SurveySetup from './SurveySetup'
import Profile from './Profile'
import Admin from './Admin'
import Export from './Export'
import Interviews from './Interviews'
import QuestionnaireDetails from './Questionnaires'
import Template from './Template'
import UsersUpload from './Users/Upload'
import ControlPanel from './ControlPanel'
import Download from './Download'
import WebInterview from './WebInterview'
import Workspaces from './ServerAdmin/Workspaces'
import MapDashboard from './MapDashboard'
import UsersManagment from './Users/UsersManagment'

export default [
    Assignments,
    Administration,
    Reports,
    Review,
    Users,
    Maps,
    WebInterviewSetup,
    SurveySetup,
    Profile,
    Admin,
    Export,
    Interviews,
    QuestionnaireDetails,
    Template,
    UsersUpload,
    ControlPanel,
    Download,
    WebInterview,
    Workspaces,
    MapDashboard,
    UsersManagment,
]
